import { setupFactories } from '@webnuts/component-factories/build/setup-factories'
import { FactoryButton } from '@webnuts/component-factories/build/factories/buttons/Button'
import { FactoryBox, FactoryMostlyFluid } from '@webnuts/component-factories/build/factories/layouts'
import { FactoryAnchor, FactoryText } from '@webnuts/component-factories/build/factories/typographies'
import { FactoryInputText } from '@webnuts/component-factories/build/factories/inputs'

export const {
  //
  BREAKPOINTS,
  createButtonComponents,
  createButtonVariantComponents,
  createMostlyFluidComponents,
  createMostlyFluidVariantComponents,
  createBoxComponents,
  createBoxVariantComponents,
  createAnchorComponents,
  createAnchorVariantComponents,
  createTextComponents,
  createTextVariantComponents,
  createInputTextComponents
} = setupFactories(
  {
    Button: FactoryButton,
    MostlyFluid: FactoryMostlyFluid,
    Box: FactoryBox,
    Anchor: FactoryAnchor,
    Text: FactoryText,
    InputText: FactoryInputText
  },

  { xlarge: 1200, large: 990, medium: 480, small: 0 }
)
